import { t } from '@/i18n';

/**
 * Prezentacja statusu VAT z rejestru (Biała Lista / VIES). Osobno od dialogu
 * edycji kontrahenta, bo ten sam status pokazuje też karta klienta w CRM-ie.
 */

/** i18n label for a source-native VAT status; falls back to the raw value. */
export function vatStatusLabel(status: string | null): string | null {
  if (!status) return null;
  switch (status) {
    case 'Czynny':
      return t('registry.vatStatusActive');
    case 'Zwolniony':
      return t('registry.vatStatusExempt');
    case 'Niezarejestrowany':
      return t('registry.vatStatusNotRegistered');
    case 'VIES-valid':
      return t('registry.viesValid');
    case 'VIES-invalid':
      return t('registry.viesInvalid');
    default:
      return status;
  }
}

/** Whether the status means "positively verified". */
export function vatStatusPositive(status: string | null): boolean {
  return status === 'Czynny' || status === 'VIES-valid';
}
